/**
 * <Website 
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import WebsiteSideMenu from './WebsiteSideMenu';
import Preview from './Preview';
import ComponentEditor from './ComponentEditor';
import './Website.scss'
import locale from './locale';

import AddComponent from './AddComponent';
import ThemeSetting from './ThemeSetting';
import NavSetting from './NavSetting';
import WebsiteSetting from './WebsiteSetting';
import SelectTheme from './SelectTheme';
import EditPageOnSideMenu from './EditPageOnSideMenu';
import PageEditor from './PageEditor';

import createPoster from 'controllers/poster/createPoster';
import updatePoster from 'controllers/poster/updatePoster';
import createContent from 'controllers/poster/createContent';
import updateContent from 'controllers/poster/updateContent';
import deleteContent from 'controllers/poster/deleteContent';
import getPosterDetail from 'controllers/poster/getPosterDetail';
import updateSchoolSettings from 'controllers/school/updateSchoolSettings';

import { confirm, } from 'util/confirm'
import { alert, } from 'util/alert'

class Website extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openPreview: false,
      editFormSchema: {},
      themeInfo: {},
      currentPagePath: '/',
    }

    this.onEndEdit = this.onEndEdit.bind(this);
    this.onStartEdit = this.onStartEdit.bind(this);
    this.onIframeLoaded = this.onIframeLoaded.bind(this);
    this.onComponentChange = this.onComponentChange.bind(this);
    this.onComponentSubmit = this.onComponentSubmit.bind(this);
 
    this.onPageChange = this.onPageChange.bind(this);
    this.onClosePageEditor = this.onClosePageEditor.bind(this);  
    this.onPageSubmit = this.onPageSubmit.bind(this);
    this.onPageDelete = this.onPageDelete.bind(this);
    this.onSettingSubmit = this.onSettingSubmit.bind(this);
    
    this.onAddComponent = this.onAddComponent.bind(this);
    this.onDeleteComponent = this.onDeleteComponent.bind(this);
    this.onSubmitAddComponent = this.onSubmitAddComponent.bind(this);
    this.onMoveComponent = this.onMoveComponent.bind(this);
  
    this.onCurrentPageChange = this.onCurrentPageChange.bind(this);
  }


  componentWillMount() {

  }

  onComponentChange(componentUnderEdit) {
    this.setState({
      componentUnderEdit,
    });
  }

  onPageChange() {

  }

  onClosePageEditor() {
    this.setState({
      isPageEdit: false,    
    });
  }

  onPageSubmit(page) {

    let nextAction;
    if (typeof page.id == 'undefined') {
      nextAction = 'create_new_page';
    } else {
      nextAction = 'update_page';
    }

    switch (nextAction) {
      case 'create_new_page': {
        this.createNewPage(page);
        break;
      }
      case 'update_page': {
        this.updatePage(page);
        break;
      }
    }
  }

  createNewPage(page) {
    const schoolId = localStorage.getItem('schoolId');
  
    createPoster(schoolId, {
      poster_type: 'web_page',
      title: page.title,
      state: 'published',
      page_setting: page.page_setting,
    })
    .then((res)=> {
      if (res && res.result == 'success') {
        this.onClosePageEditor();
        this.refreshPage();
        
      }
    })
    .catch((err)=>{
      console.error(err);
    });
  }

  onPageDelete() {
    const {
      page,
    } = this.state;
  }

  updatePage(page) {
    updatePoster(page.id, {
      state: 'draft',
    })
    .then((res)=> {
      return updatePoster(page.id, {
        title: page.title,
        state: 'published',
        page_setting: page.page_setting,
      });
    })
    .then((res)=>{
      this.onClosePageEditor();
      this.refreshPage();
    })
    .catch((err)=>{
      console.error(err);
    });
  
  }

  // both ThemeSettings and WebsiteSettings are usting the same controller
  onSettingSubmit(site) {
    const schoolId = localStorage.getItem('schoolId');

    const {
      theme,
      siteUrl,
      themeUrl,
      themeSetting,
      locale,
      nav,
    } = site;
      
    const toSubmit = {
      website_locale: locale,
      website_url: siteUrl,
      website_theme_name: theme,
      website_theme_settings: themeSetting,
      website_nav_settings: nav,
    }

    updateSchoolSettings(schoolId, toSubmit)
      .then((res)=> {
        this.refreshPage();
        this.sideMenuMethods.backToPrevious(); 
      });
  }

  onStartEdit(eventData) {
    const {
      componentFormSchemas,
      componentFormData,
    } = eventData.__edit;

    const {
      componentType,
      contentId,
    } = eventData;

    const editFormSchema = componentFormSchemas[componentType];

    const componentUnderEdit = componentFormData[contentId];
      
    // controller to get componentUnderEdit
    this.setState({
      editFormSchema,
      isComponentEdit: true,
      componentUnderEdit,
      componentIdUnderEdit: contentId,
    });
  }

  onCurrentPageChange(currentPagePath) {
    this.setState({
      currentPagePath,
    });
  }

  onEndEdit() {
    this.setState({
      isComponentEdit: false,
      isPageEdit: false,
      isAddComponent: false,
      editFormSchema: {},
      componentUnderEdit: {},
      componentIdUnderEdit: null,
    });
  }

  onDeleteComponent(eventData) {
    const {
      id,
    } = this.state.page;
      
    const {
      deleteComponentId,
    } = eventData;

    if (typeof deleteComponentId == 'number') {
      let deleteSuccess = '';
      confirm(__('Are you sure you want to delete this component?', locale), __('Delete Component', locale))
        .then(()=>{
          return updatePoster(id, {
            state: "draft",
          });
        })
        .then((res)=>{
          return deleteContent(deleteComponentId)
        })
        .then((res)=>{
          deleteSuccess = res.result;
          return updatePoster(id, {
            state: "published",
          });
        })
        .then((res)=>{
          if (deleteSuccess == 'success') {
            this.refreshPage();
          } else {
            throw new Error('failed to delete');
          }
        })
        .catch((err)=>{
          alert.fail(__('We encountered an error during the process.', locale), __('Failed to Delete Component', locale));
          console.error(err);
        });
    }
  }

  onMoveComponent(eventData) {
    const {
      moveComponentIndex,
      contentId,
    } = eventData;

    const {
      id,
    } = this.state.page;

    updatePoster(id, {
      state: "draft",
    })
    .then(()=>{
      return updateContent(contentId, {
        index: moveComponentIndex,
      });
    })
    .then(()=>{
       return updatePoster(id, {
        state: "published",
      })
    })
    .then((result)=>{
      this.refreshPage();
      this.onEndEdit();
    });
  }

  onAddComponent(eventData) {
    this.setState({
      isAddComponent: true,
      addComponentIndex: eventData.addComponentIndex,
    });
  }

  onComponentSubmit() {
    const {
      id,
      page_setting,
    } = this.state.page;
    
    const {
      componentUnderEdit,
      componentIdUnderEdit,
    } = this.state;

    updatePoster(id, {
      state: "draft",
      page_setting,
    })
    .then(()=>{
      return updateContent(componentIdUnderEdit, {
        custom_data: componentUnderEdit,
      })
    })
    .then(()=>{
       return updatePoster(id, {
        state: "published",
        page_setting,
      })
    })
    .then((result)=>{
      this.refreshPage();
      this.onEndEdit();
    });
  }

  onSubmitAddComponent(component) {

    const {
      addComponentIndex,
      componentInitValues,
    } = this.state

    const {
      id,
      content = [],
      page_setting,
    } = this.state.page;

    const {
      type,
    } = component;

    let index;
    if (content.length == 0) {
      index = 1;
    } else {
      index = parseInt(addComponentIndex);
    }

    const initValue = componentInitValues[type] || {}

    updatePoster(id, {
      state: "draft",
      page_setting,
    })
    .then(()=>{
      return createContent(id, {
        index,
        content_type: type,
        custom_data: {
          type,
          ...initValue,
        }
      })
    })
    .then((err)=>{
      return updatePoster(id, {
        state: "published",
        page_setting,
      })
    })
    .then(()=>{
      this.refreshPage();
      this.onEndEdit();
    });
  
  }

  refreshPage() {
    if (this.iframeRef) {
      this.iframeRef.contentWindow.postMessage({
        type: "REFRESH",
      }, '*');
    }
  }

  onSelectMenu(menuItem) {

  }

  //
  // when iFrame is loaded, the website (in edit mode) will send an the site data through postMessage()
  // this is the handler for that event
  //
  onIframeLoaded(eventData) {
    this.setStatePageOptions(eventData.__edit);
    
    // controller to get componentUnderEdit
    this.setState({
      ...eventData.__edit,
    });
  }

  setStatePageOptions({ pages, corePages }) {
    let selectOptionForPages = [{}]; 
    
    delete corePages['::404']; // we don't need 404 to be one of options
    delete corePages['::500']; // we don't need 404 to be one of options

    _.each({ ...pages, ...corePages }, (page)=>{
      const {
        id,
        title,
      } = page;

      selectOptionForPages.push({
        label: title,
        value: id,
      });
    });
    
    this.setState({
      selectOptionForPages,
    });
  }

  render() {
    const {
      page,
      pages,
      openPreview,
      editFormSchema,
      currentPagePath,
      componentUnderEdit = {},
      isComponentEdit,
      isAddComponent,
      isPageEdit, 
      leftSettingColumnMode,
      selectOptionForPages,
      componentFormSchemas, 
    } = this.state;

    this.defaultSettingSchema = [
      {
        sectionName: "general",
        sectionLabel: "General",
        fields: [
          {
            name: "siteTitle",
            type: "text",
            label: "Site Title",
          },
          {
            name: "siteLogo",
            type: "mediaCenter",
            label: "Logo",
            selectMultiple: false,
          },
          {
            name: "homePage",
            type: "select",
            label: __('Home Page', locale),
            options: selectOptionForPages,
          },
        ] // fields
      },
    ];

    const sideMenu = { 
      title: __('Website Settings', locale), 
      items: [
        {
          title: __('Website Settings', locale),
          name: 'website_settings',
          component: ()=>{
            const {
              site,
            } = this.state;

            return (
              <WebsiteSetting 
                site={this.state.site}
                onClose={()=>{
                  this.sideMenuMethods.backToPrevious(); 
                }}
                onSubmit={this.onSettingSubmit}
              />
            );  
          }
        },
        {
          title: __('Select Theme', locale),
          name: 'select_theme',
          width: 700,
          component: ()=>{
            return <SelectTheme />
          }
        },
        {
          title: __('Theme Settings', locale),
          name: 'theme_settings',
          width: 450,
          component: ()=>{ 
            const {
              settingSchema = [],
            } = this.state.themeInfo;

            const {
              site,
            } = this.state;
            
            return (
              <ThemeSetting 
                site={site}
                settingSchema={[...this.defaultSettingSchema, ...settingSchema]} 
                onSubmitThemeSetting={this.onSettingSubmit}
                onCloseThemeSetting={()=>{
                  this.sideMenuMethods.backToPrevious(); 
                }}
              />
            );
          },
        },
        {
          title: __('Nav Settings', locale),
          name: 'nav_settings',
          width: 450,
          component: ()=>{ 
            const {
              site,
              selectOptionForPages,
            } = this.state;
            
            return (
              <NavSetting 
                site={site}
                onSubmit={this.onSettingSubmit}
                selectOptionForPages={selectOptionForPages}
                onClose={()=>{
                  this.sideMenuMethods.backToPrevious(); 
                }}
              />
            );
          },
        },
        
        {
          title: __('Edit Page', locale),
          name: 'edit_page',
          component: ()=>{
            const {
              page,
              pages,
              site,
            } = this.state;
            return (
              <EditPageOnSideMenu
                site={site}
                page={page}
                pages={pages}
                onChange={this.onCurrentPageChange}
                onStartEdit={(page)=>{
                  this.setState({
                    isPageEdit: true,
                    page,
                  });
                }} 
              />
            );
          }
        },
      ],
    }

    let isEdit = false;

    if (isComponentEdit || isPageEdit || isAddComponent) {
      isEdit = true;        
    }

    return (
      <div className='Website'>
        <WebsiteSideMenu 
          menu={sideMenu}
          onSelectMenu={this.onSelectMenu}
          getMethodsOnLoad={(methods)=>{
            this.sideMenuMethods = methods;
          }}
        />
        <Preview 
          isEdit={isEdit}
          currentPagePath={currentPagePath}
          page={page}
          onEndEdit={this.onEndEdit}
          onStartEdit={this.onStartEdit}
          onAddComponent={this.onAddComponent}
          onMoveComponent={this.onMoveComponent}
          onDeleteComponent={this.onDeleteComponent}
          openPreview={openPreview} 
          editFormSchema={editFormSchema}
          onIframeLoaded={this.onIframeLoaded}
          registerIframeRef={(r)=>{ this.iframeRef = r; }}
        />
        <div className={classnames('editMask', { isEdit })} onClick={this.onEndEdit}></div>
        <AddComponent
          isEdit={isAddComponent}
          onSubmit={this.onSubmitAddComponent}
          onCloseEditor={this.onEndEdit}
          componentFormSchemas={componentFormSchemas}
        />
        <ComponentEditor 
          isEdit={isComponentEdit}
          editFormSchema={editFormSchema} 
          editFormData={componentUnderEdit}
          onComponentChange={this.onComponentChange}
          onSubmit={this.onComponentSubmit}
          onCloseEditor={this.onEndEdit}
        />
        <PageEditor 
          isEdit={isPageEdit}
          page={page}
          onDelete={this.onPageDelete}
          onSubmit={this.onPageSubmit}
          onClose={this.onClosePageEditor}
        />
      </div>
    )
  }

  
}

export default Website;



// WEBPACK FOOTER //
// ./src/containers/pages/Website/index.js